
import { computed, ComputedRef, defineComponent, onMounted, watch } from "vue";
import { useStore } from "vuex";
import ContentComment from "./ContentComment.vue";
import { Content, ContentDoubt } from "./helpers";
import { dispatchError } from "../../utils/error_handling";

export default defineComponent({
  name: "ContentDoubtsList",
  components: { ContentComment },
  setup() {
    const store = useStore();

    onMounted(async () => await onCurrentContentChange());

    const currentContent: ComputedRef<Content> = computed(
      () => store.getters["content_module/currentContent"]
    );
    watch(currentContent, async () => await onCurrentContentChange());

    const onCurrentContentChange = async (): Promise<void> => {
      try {
        await loadDoubts();
      } catch (e) {
        console.error("[onCurrentContentChange] Error loadDoubts", e);
        await dispatchError(e);
      }
    };

    const loadDoubts = async (): Promise<void> => {
      try {
        await store.dispatch("content_module/doubt/loadDoubts");
      } catch (e) {
        console.error("[loadDoubts] Error dispatch", e);
        throw e;
      }
    };

    const contentDoubts: ComputedRef<ContentDoubt[]> = computed(
      () => store.getters["content_module/doubt/contentDoubts"]
    );

    return {
      contentDoubts
    };
  }
});
